import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { makeStyles } from "@material-ui/core/styles";
//import axios from 'axios';
//import {API_URL} from '../utils/EnvVars';


const useStyles = makeStyles({
    paper: {
      fontSize: '12px !important',    
    }
  });

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export default function Asynchronous(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  ///const [inputVal, setInputVal] = React.useState("");
  
  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3); 
      if (active && options && options.length<1) {
        //setOptions([...topFilms]);
        setOptions(props.topicsList);   
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  function selectedValue(obj){
    if(obj){
        props.selectTopic(obj);
    }    
  }

  const filterOptions = createFilterOptions({    
    matchFrom: 'start',
    stringify: option => option.topicName,
  });

  // const filterOptions = (options, state) => {
  //   let newOptions = [];
  //   options.forEach((element) => {
  //     if (
  //       element.topicName
  //         .replace(",", "")
  //         .toLowerCase()
  //         .includes(state.inputValue.toLowerCase())
  //     )
  //       newOptions.push(element);
  //   });
  //   return newOptions;
  // };
  
  return (
    <>
    <Autocomplete 
      value={{ topicName: props.topicName }}
      id="search-input-topicbox"
      freeSolo={false}
      classes={{ paper: classes.paper }}
      sx={{ width: '99%' }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option.topicName === value.topicName}
      getOptionLabel={(option) => ((option && option.topicName)?option.topicName:'')}
      options={options}
      loading={loading}
      filterOptions={filterOptions}
      onChange={(event, myObj) => selectedValue(myObj)}
      // onInputChange={(event, newInput) => {
      //   setInputVal(newInput);
      // }}     
      size="small"
      renderInput={(params) => (
        <TextField           
          {...params}
          label={props?.label?props.label:'Select'}    
          variant={props?.variant?props.variant:'standard'}       
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          
        />
      )}
    />


    
    </>
  );
}

